<div class="modal-body">
  <p>{{ dialogData.data.para }}</p>

  <div class="container">
    <form [formGroup]="signApp" (ngSubmit)="onSubmit()">
      <div class="">
        <div>
          <div class="col-sm-12 col-md-4 frm-field padding0">
            <label for="insured">{{
              formFields?.insuredEmailField?.fieldInfo.label
            }}</label>
            <input
              type="text"
              maxlength="80"
              tabindex="1"
              id="insured"
              formControlName="insuredEmail"
              class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.insuredEmail.errors }"
            />

            <div
              *ngIf="submitted && f.insuredEmail.errors"
              class="invalid-feedback"
            >
              <div *ngIf="f.insuredEmail.errors.required">
                {{ formFields?.insuredEmailField?.fieldInfo.label }}
                {{ f.insuredEmail['requiredError'] }}
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="col-sm-12 col-md-4 frm-field padding0">
            <label for="producer">{{
              formFields?.producerEmailField?.fieldInfo.label
            }}</label>
            <select
              tabindex="5"
              id="producer"
              formControlName="producerEmail"
              class="form-control"
            >
              <option value="nrepaci@tmhcc.com" selected
                >nrepaci@tmhcc.com</option
              >
              <option value="">mbartels@tmhcc.com</option>
            </select>
          </div>
        </div>
      </div>
      <div class="button">
        <button type="button" class="btn btn-primary cancel">
          {{ signAppBtn[4]?.keyText }}
        </button>
        <button class="btn btn-primary lftMar10" type="submit">
          {{ signAppBtn[5]?.keyText }}
        </button>
      </div>
    </form>
  </div>
</div>
